<template>
  <div class="animated fadeIn">
    <!-- Filtros -->
    <b-card header-tag="header">
      <div slot="header">
        <i class="icon-screen-smartphone"></i> Credenciamentos
        <b-button size="sm" variant="primary" class="float-right" @click="openQrModal">
          <i class="fa fa-qrcode"></i> Novo
        </b-button>
      </div>
      <b-card-body>
        <div class="form-row">
          <div class="col-md-3">
            <div class="form-group">
              <label>Empresa</label>
              <model-list-select
                :list="sellers.data"
                option-value="id"
                option-text="name"
                v-model="searchModel.sellerId"
                placeholder="Digite o nome da empresa"
                @searchchange="searchSellersList"
              ></model-list-select>
            </div>
          </div>
          <div class="col-md-2">
            <base-input label="CPF / CNPJ"          v-model="searchModel.documentNumber" placeholder />
          </div>
          <div class="col-md-2">
            <base-input label="Serial Number"        v-model="searchModel.serialNumber"   placeholder />
          </div>
          <div class="col-md-2">
            <base-input label="Código de ativação"   v-model="searchModel.activationCode" placeholder />
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label>Status</label>
              <select class="custom-select" v-model="searchModel.status">
                <option v-for="(s, index) in statusList" :key="index" :value="s.id">{{ s.name }}</option>
              </select>
            </div>
          </div>
        </div>
        <b-row>
          <b-col md="6" class="my-1">
            <b-input-group>
              <b-input-group-append>
                <b-button @click="search" variant="primary">Buscar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Tabela -->
    <b-card>
      <b-table :items="result.data" :fields="fields" :striped="true" responsive>
        <template slot="status" slot-scope="data">
          {{ bindStatusName(data.value) }}
        </template>
        <template slot="kind" slot-scope="data">
          {{ bindKindName(data.value) }}
        </template>
        <template slot="updatedAt" slot-scope="data">
          {{ data.value | formatDate }}
        </template>
        <template slot="actions" slot-scope="row">
          <b-link :to="`/partners/enrollments/edit/${row.item.activationCode}`" class="btn btn-sm btn-primary mr-1">
            <i class="fa fa-edit"></i>
          </b-link>
        </template>
      </b-table>
      <nav>
        <b-pagination
          :total-rows="result.rowCount"
          :per-page.sync="result.pageSize"
          v-model="currentPage"
          prev-text="Voltar"
          next-text="Próximo"
          @change="pageIndexChanged"
          first-text="Primeiro"
          last-text="Último"
        />
      </nav>
    </b-card>

    <!-- Modal QR Code -->
    <b-modal
      v-model="qrModalVisible"
      title="Escanear QR Code"
      hide-footer
      @hidden="stopCamera"
    >
      <div v-if="qrError" class="alert alert-danger">{{ qrError }}</div>

      <div v-if="qrModalVisible" style="width:100%">
        <qrcode-stream @decode="onQrDecode" @init="onCameraInit" />
      </div>

      <p class="text-muted text-center mt-2 mb-0">
        <small>Aponte a câmera para o QR Code do terminal</small>
      </p>

      <hr />

      <div class="form-group">
        <label>Ou digite o código de ativação manualmente</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Ex: ABC-123456"
            v-model="manualCode"
            @keyup.enter="goWithManualCode"
          />
          <div class="input-group-append">
            <b-button variant="primary" :disabled="!manualCode.trim()" @click="goWithManualCode">
              <i class="fa fa-arrow-right"></i> Ir
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import enrollmentService from '../../../services/Devices/enrollmentService';
import sellerService from '../../../services/Customer/sellerService';
import listPage from '../../../mixins/listPage';
import { ModelListSelect } from 'vue-search-select';
import { QrcodeStream } from 'vue-qrcode-reader';
import moment from 'moment';

export default {
  components: { ModelListSelect, QrcodeStream },

  mixins: [listPage],

  filters: {
    formatDate(value) {
      if (!value) return '';
      return moment(value).format('DD/MM/YYYY HH:mm');
    },
  },

  data() {
    return {
      actionUri: 'partners/enrollments',
      fields: [
        { key: 'serialNumber',   label: 'Serial Number',  sortable: false },
        { key: 'activationCode', label: 'Cód. Ativação',  sortable: false },
        { key: 'sellerName',     label: 'Empresa',        sortable: false },
        { key: 'sellerDocument', label: 'CNPJ / CPF',     sortable: false },
        { key: 'kind',           label: 'Tipo',           sortable: false },
        { key: 'status',         label: 'Status',         sortable: false },
        { key: 'updatedAt',      label: 'Atualizado em',  sortable: false },
        { key: 'actions',        label: '' },
      ],
      statusList: [],
      sellers: { data: [] },
      searchModel: {
        page: 1,
        serialNumber: '',
        activationCode: '',
        status: null,
        sellerId: null,
        documentNumber: '',
      },
      currentPage: 1,
      qrModalVisible: false,
      qrError: null,
      manualCode: '',
    };
  },

  created() {
    this.statusList = [{ id: null, name: 'Todos' }, ...enrollmentService.getStatusList()];
  },

  methods: {
    openQrModal() {
      this.qrError = null;
      this.manualCode = '';
      this.qrModalVisible = true;
    },

    goWithManualCode() {
      const code = this.manualCode.trim();
      if (!code) return;
      this.qrModalVisible = false;
      this.$router.push({ path: '/partners/enrollments/new', query: { code } });
    },

    stopCamera() {
      this.qrModalVisible = false;
    },

    async onCameraInit(promise) {
      try {
        await promise;
      } catch (e) {
        if (e.name === 'NotAllowedError') {
          this.qrError = 'Permissão de câmera negada. Autorize o acesso e tente novamente.';
        } else if (e.name === 'NotFoundError') {
          this.qrError = 'Nenhuma câmera encontrada neste dispositivo.';
        } else {
          this.qrError = 'Não foi possível iniciar a câmera.';
        }
      }
    },

    onQrDecode(content) {
      const activationCode = this.extractActivationCode(content);
      if (!activationCode) {
        this.qrError = 'QR Code inválido. Não foi possível identificar o código de ativação.';
        return;
      }
      this.qrModalVisible = false;
      this.$router.push({ path: '/partners/enrollments/new', query: { code: activationCode } });
    },

    // Suporta QR com URL (extrai query ?code= ou último segmento do path)
    // ou o código bruto diretamente
    extractActivationCode(content) {
      if (!content) return null;
      try {
        const url = new URL(content);
        const code = url.searchParams.get('code');
        if (code) return code;
        const segments = url.pathname.split('/').filter(Boolean);
        return segments[segments.length - 1] || null;
      } catch (_) {
        // Não é URL — usa o conteúdo direto como código
        return content.trim() || null;
      }
    },

    searchSellersList(query) {
      if (!query || query.length < 2) return;
      const self = this;
      this.showLoading();
      sellerService.all(query).then(
        (response) => {
          self.sellers.data = response.status === 204 ? [] : response.data;
          self.hideLoading();
        },
        () => { self.hideLoading(); }
      );
    },

    fetchData(page) {
      this.searchModel.page = page;
      const self = this;
      this.showLoading();
      enrollmentService.findAll(this.searchModel).then(
        (response) => {
          self.result = response.status === 204 ? self.getEmptyResult() : response.data;
          self.hideLoading();
        },
        () => { self.hideLoading(); }
      );
    },

    pageIndexChanged(page) {
      this.currentPage = page;
      this.fetchData(page);
    },
    bindKindName(kind) {
      return enrollmentService.getKindName(kind);
    },
    bindStatusName(status) {
      return enrollmentService.getStatusName(status);
    },
  },
};
</script>
